import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Contract } from "src/app/shared/models/DTO/VenueFinance.dto";

@Component({
	selector: "app-contract-dashboard",
	templateUrl: "./contract-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ContractDashboardComponent implements OnInit {
	@Input() contract: Contract;
	@Output() contractChange = new EventEmitter<Contract>();

	mainContract: Contract = new Contract();

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.venueFinance.subscribe((data) => {
			if (data.contracts) {
				this.setMainContract(data.contracts);
			}
		});

		if (this.venueService.venueFinance.value.contracts) {
			this.setMainContract(this.venueService.venueFinance.value.contracts);
		}
	}

	setMainContract(contractList: Contract[]) {
		let furtherestExpiration: number = 0;
		let contractKey: string;

		contractList.forEach((contract) => {
			if (this.app.moment(contract.endDate).unix() > furtherestExpiration && contract.active) {
				furtherestExpiration = this.app.moment(contract.endDate).unix();
				contractKey = contract.key;
			}
		});

		this.mainContract = contractList.find((i) => i.key === contractKey);
		return this.mainContract;
	}
}
